@if (waitingForFilterResults) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

@if (!waitingForFilterResults && workflowTaskingList.length === 0) {
  <div class="empty-state">
    <p>No workflow requests are assigned to you.</p>
  </div>
}

<ag-grid-angular
  style="width: 100%; height: 500px;"
  class="ag-theme-balham"
  [rowData]="workflowTaskingList"
  [columnDefs]="taskingColumns"
  (gridReady)="onGridReady($event)"
  (rowClicked)="onRowClicked($event)"
  >
</ag-grid-angular>
